export const GET_NOTES = "GET_NOTES"
export const GET_NOTE_LISTS = "GET_NOTE_LISTS"
export const GET_CHOOSE_NOTE = "GET_CHOOSE_NOTE"
export const CREATE_NEW_NOTE = "CREATE_NEW_NOTE"
export const UPDATE_NOTE = "UPDATE_NOTE"
export const DEL_NOTE = "DEL_NOTE"
export const INITIAL_STATES = "INITIAL_STATES"
export const GET_NOTE_STATUSES = "GET_NOTE_STATUSES"
export const UPDATE_NOTE_STATUS = "UPDATE_NOTE_STATUS"
export const GET_COUNTER_DATA = "GET_COUNTER_DATA"
export const RESET_JOB_NOTES = "RESET_JOB_NOTES";